const SMALL_LETTER = 'password-condition.small-letter';
const CAPITAL_LETTER = 'password-condition.capital-letter';
const SPECIAL_CHARACTER = 'password-condition.special-character';
const DIGIT_PRESENT = 'password-condition.digit-present';
const MIN_LENGTH = 'password-condition.min-length';
const NO_REPETITIVE_SEQUENCES = 'password-condition.repetitive-sequences';
const DIFFERENT_THAN_EMAIL = 'password-condition.different-than-email';


export interface PasswordCondition {
	matches(password: string): boolean;

	type(): string;
}

export class SmallLetterCondition implements PasswordCondition {
	matches(password: string): boolean {
		return password.toUpperCase() != password;
	}

	type(): string {
		return SMALL_LETTER;
	}
}

export class CapitalLetterCondition implements PasswordCondition {
	matches(password: string): boolean {
		return password.toLowerCase() != password;
	}

	type(): string {
		return CAPITAL_LETTER;
	}
}

export class SpecialCharacterCondition implements PasswordCondition {
	matches(password: string): boolean {
		return /\W/.test(password);
	}

	type(): string {
		return SPECIAL_CHARACTER;
	}
}

export class DigitPresentCondition implements PasswordCondition {
	matches(password: string): boolean {
		return /\d/.test(password);
	}

	type(): string {
		return DIGIT_PRESENT;
	}
}

export class MinimumLengthCondition implements PasswordCondition {

	constructor(private minLength: number) {
	}

	matches(password: string): boolean {
		return password.replace(/ /g, '').length >= this.minLength;
	}

	type(): string {
		return `${MIN_LENGTH}-${this.minLength}`;
	}
}

export class NoRepetitiveSequencesCondition implements PasswordCondition {

	matches(password: string): boolean {
		return !this.hasSequentialCharacters(password);
	}

	private hasSequentialCharacters(password: string): boolean {
		for (let i = 0; i < password.length; i++) {
			if (this.repeatedChars(password, i) || this.orderedSequentialChars(password, i) || this.reversedSequentialChars(password, i)) {
				return true;
			}
		}

		return false;
	}

	private repeatedChars(password: string, i: number): boolean {
		return (password.charCodeAt(i)) === password.charCodeAt(i + 1) &&
			(password.charCodeAt(i + 1)) === password.charCodeAt(i + 2) &&
			(password.charCodeAt(i + 2)) === password.charCodeAt(i + 3);
	}

	private orderedSequentialChars(password: string, i: number): boolean {
		return (password.charCodeAt(i) + 1) === password.charCodeAt(i + 1) &&
			(password.charCodeAt(i + 1) + 1) === password.charCodeAt(i + 2) &&
			(password.charCodeAt(i + 2) + 1) === password.charCodeAt(i + 3);
	}

	private reversedSequentialChars(password: string, i: number): boolean {
		return (password.charCodeAt(i)) === password.charCodeAt(i + 1) + 1 &&
			(password.charCodeAt(i + 1)) === password.charCodeAt(i + 2) + 1 &&
			(password.charCodeAt(i + 2)) === password.charCodeAt(i + 3) + 1;
	}

	type(): string {
		return NO_REPETITIVE_SEQUENCES;
	}
}

export class DifferentThanEmailCondition implements PasswordCondition {

	constructor(private email: string) {
	}

	matches(password: string): boolean {
		return password.toLowerCase() != this.email.toLowerCase();
	}

	type(): string {
		return DIFFERENT_THAN_EMAIL;
	}
}
